module.exports = __webpack_public_path__ + "img/question2.abc1341d.svg";